import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient,  HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { CustomInterceptor } from './../../../helper';
import { SharedModule } from '../../shared';
import { SelectModule } from 'ng-select';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule, ModalModule, TimepickerModule } from 'ngx-bootstrap';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

// import { EcallDisplayIdModule, EquipmentDisplayIdModule, EcallStatusNum2StatusNameModule, DisplayIdModule } from '../../../directives';
import { EcallStatusNum2StatusNameModule, DisplayIdModule } from '../../../directives';

import { EcallRoutingModule } from './ecall-routing.module';
import { EcallSummaryComponent, EcallSummaryService } from './ecall-summary';
import { EcallDetailComponent, EcallDetailService, EcallEquipmentSummaryComponent,
  EcallEquipmentSummaryService, EcallCancelService } from './ecall-detail';
import { EcallCreateComponent, EcallCreateService } from './ecall-create';
import { EcallEditComponent, EcallEditService } from './ecall-edit';
import { EcallPdfSummaryComponent } from './ecall-pdf-summary/ecall-pdf-summary.component';
import { EcallPdfAddComponent } from './ecall-pdf-add/ecall-pdf-add.component';
import { EcallService } from './ecall.service';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    
    ReactiveFormsModule,
    SharedModule,
    EcallRoutingModule,
    DisplayIdModule,
    // EcallDisplayIdModule,
    // EquipmentDisplayIdModule,
    EcallStatusNum2StatusNameModule,
    SelectModule,
    AngularMultiSelectModule,
    NgbModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    ModalModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    EcallSummaryComponent,
    EcallDetailComponent,
    EcallEquipmentSummaryComponent,
    EcallCreateComponent,
    EcallEditComponent,
    EcallPdfSummaryComponent,
    EcallPdfAddComponent
  ],
  providers: [
    DatePipe,
    EcallSummaryService,
    EcallDetailService,
    EcallEquipmentSummaryService,
    EcallEditService,
    EcallCreateService,
    EcallCancelService,
    EcallService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true }
  ]
})
export class EcallModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall.module.ts